/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateProductPageComponentsContentutationRequest,
  UpdateProductPageComponentsContentutationResponse,
  UpdateProductPageComponentsContentathParams,
} from "../types/UpdateProductPageComponentsContent.ts"

export const updateProductPageComponentsContentutationKey = () =>
  [
    { url: "/v1/organization-settings/product-page-components/content/:id" },
  ] as const

export type UpdateProductPageComponentsContentutationKey = ReturnType<
  typeof updateProductPageComponentsContentutationKey
>

/**
 * @summary Update product page component content
 * {@link /v1/organization-settings/product-page-components/content/:id}
 */
export async function updateProductPageComponentsContent(
  id: UpdateProductPageComponentsContentathParams["id"],
  data: UpdateProductPageComponentsContentutationRequest,
  config: Partial<
    RequestConfig<UpdateProductPageComponentsContentutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateProductPageComponentsContentutationResponse,
    ResponseErrorConfig<Error>,
    UpdateProductPageComponentsContentutationRequest
  >({
    method: "PATCH",
    url: `/v1/organization-settings/product-page-components/content/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateProductPageComponentsContentutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<UpdateProductPageComponentsContentutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = updateProductPageComponentsContentutationKey()
  return mutationOptions<
    ResponseConfig<UpdateProductPageComponentsContentutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateProductPageComponentsContentathParams["id"]
      data: UpdateProductPageComponentsContentutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateProductPageComponentsContent(id, data, config)
    },
  })
}

/**
 * @summary Update product page component content
 * {@link /v1/organization-settings/product-page-components/content/:id}
 */
export function useUpdateProductPageComponentsContent<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateProductPageComponentsContentutationResponse>,
      ResponseErrorConfig<Error>,
      {
        id: UpdateProductPageComponentsContentathParams["id"]
        data: UpdateProductPageComponentsContentutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateProductPageComponentsContentutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ??
    updateProductPageComponentsContentutationKey()

  const baseOptions = updateProductPageComponentsContentutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateProductPageComponentsContentutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateProductPageComponentsContentathParams["id"]
      data: UpdateProductPageComponentsContentutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateProductPageComponentsContentutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateProductPageComponentsContentathParams["id"]
      data: UpdateProductPageComponentsContentutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateProductPageComponentsContentutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateProductPageComponentsContentathParams["id"]
      data: UpdateProductPageComponentsContentutationRequest
    },
    TContext
  >
}
